import { ApiError, ApiParameter } from "@insite/client-framework/Services/ApiService";
import { GetPreviewParameter } from "@tSurya/Services/HangtagPreviewService";

export const HangtagDownloadPdfUrl ="api/v2/generateHangtagPdf"

export async function DownloadHangtagPdf(params:GetPreviewParameter) {    
    const response = await fetch(`${HangtagDownloadPdfUrl}`,{
        method:"POST",
        headers:{
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params)
    });

    try{
        const result = response.ok && (await response.blob())
        if(!response.ok){
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            )
        }
        return result;
    } catch(error){
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(HangtagDownloadPdfUrl , response, message, errorJson);
    }
}